export default __webpack_public_path__ + "static/media/DarkEditPencil.5b690774.svg";